/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-07-29.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-07-29.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-07-29.mdx';

const metadata = {
  slug: "2020-07-29",
  title: "Vite + Vue 3 + Preact + Hooks + UseGesture",
  author: "Christian Battaglia",
  description: "Debugging why styled-components don't work with Preact in Vite, 3:30am productivity sessions, and working through NPM packages for the personal website rebuild.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-07-29T00:00:00.000Z",
  
  readTime: "2 min read",
  tags: ["Vite","Preact","React","Vue 3","hooks","styled-components","useGesture","NPM"],
};

export const Route = createFileRoute('/blog/posts/2020-07-29')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-07-29',
    image: '/og/blog/2020-07-29.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
